import * as $ from 'jquery';

export default class Map {
	constructor() {
		let stateOptions = new Array();

		const select = $('.mapArea__stateOptions');
		select.find('option').each(function (index, element) {
			const stateId = element.getAttribute('value');
			// console.log(element);
			if (stateId === undefined || stateId.length === 0)
				return;

			const region = $('#' + stateId);
			region.addClass('map-region--option');

			region.on('click', function() {
				select.val(stateId);
				select.trigger('change');
			})
		});
	}
}
